import { computed } from 'vue'

import i18n from '@/libs/i18n'

const { t } = i18n.global

export const $NilObjectId = '000000000000000000000000'

export const PredefinedText = computed(() => {
    return {
        ErrorLoadData: t('errors.load_data'),
        ErrorOnAdd: t('errors.on_add'),
        ErrorOnEdit: t('errors.on_edit'),
        ErrorOnDelete: t('errors.on_delete'),
        ErrorOnSort: t('errors.on_sort'),
        ErrorOnUploadImage: t('errors.on_upload_image'),
        ErrorOnUploadFile: t('errors.on_upload_file'),
        ErrorOnCopyToClipboard: t('errors.on_copy_to_clipboard'),
        AddSuccess: t('success.on_add'),
        EditSuccess: t('success.on_edit'),
        UpdateSuccess: t('success.on_update'),
        SortSuccess: t('success.on_sort'),
        DeleteSuccess: t('success.on_delete'),
        DeleteRow: t('confirmations.delete_row'),
        DeactivateRow: t('confirmations.deactivate_row'),
        UsernameTaken: t('errors.user_exist'),
        ChannelPackageActivated: t('success.channel_package_activated'),
        ChannelPackageDeactivated: t('success.channel_package_deactivated'),
        DeviceActivated: t('success.device_activated'),
        DeviceDeactivated: t('success.device_deactivated'),
        ErrorLoadUserData: t('errors.load_user_data'),
        CopyToClipboardSuccess: t('success.on_copy_to_clipboard'),
        DeleteKey: t('confirmations.header')
    }
})

export enum FilterTypes {
    Text = 1,
    Number,
    Date,
    Select,
    MultiSelect,
    Boolean
}

export enum BasicOverviewType {
    Text = 1,
    Boolean,
    TextWithColor,
    Sensitive,
    Image,
    Date
}

export const metrics_suffixes = computed(() => {
    return [
        t('metrics_suffixes.bytes'),
        t('metrics_suffixes.kb'),
        t('metrics_suffixes.mb'),
        t('metrics_suffixes.gb'),
        t('metrics_suffixes.tb')
    ]
})

export const MetricType = {
    Base: 'base',
    CPU: 'cpu',
    NetworkInterface: 'network_interface',
    Storage: 'storage',
    Memory: 'memory',
    DailyWatch: 'daily_watch',
    ActiveConnections: 'active_connections',
    AverageConnections: 'average_connections',
    WatchMinutes: 'watch_minutes',
    WatchUsers: 'watch_users',
    WatchTime: 'watch_time',
    TopChannels: 'top_channels',
    TopClients: 'top_clients'
}

export const allowedClientLanguages = computed(() => {
    return [
        {
            name: t('languages.croatian'),
            language: 'hr'
        },
        {
            name: t('languages.english'),
            language: 'en'
        }
    ]
})

// there is 128 colors for 128 processor cores. After that colors repeat.
export const chart_colors = [
    '#64B5F6', '#E57373', '#81C784', '#FFF176', '#BA68C8', '#4DD0E1', '#A1887F', '#D4E157',
    '#81C784', '#CE93D8', '#4DB6AC', '#7986CB', '#FFB74D', '#A1887F', '#80CBC4', '#AED581',
    '#FF8A65', '#F06292', '#AB47BC', '#FBC02D', '#388E3C', '#D32F2F', '#5C6BC0', '#78909C',
    '#26C6DA', '#9C27B0', '#EC407A', '#FFD54F', '#8E24AA', '#B3E5FC', '#A5D6A7', '#26A69A',
    '#90A4AE', '#66BB6A', '#D05CE3', '#9575CD', '#4CAF50', '#7986CB', '#00E676', '#D81B60',
    '#303F9F', '#C0CA33', '#9CCC65', '#FFAB91', '#26A69A', '#90A4AE', '#76FF03', '#90CAF9',
    '#C6FF00', '#F48FB1', '#E57373', '#512DA8', '#EF9A9A', '#E0F7FA', '#A5D6A7', '#F8BBD0',
    '#FFAB91', '#26A69A', '#64B5F6', '#90A4AE', '#80DEEA', '#66BB6A', '#FF7043', '#BA68C8',
    '#FDD835', '#A5D6A7', '#B2EBF2', '#F06292', '#F44336', '#4DB6AC', '#E040FB', '#FBC02D',
    '#C0CA33', '#673AB7', '#A1887F', '#FFCC80', '#80CBC4', '#DCE775', '#E57373', '#FF8A65',
    '#64B5F6', '#D81B60', '#00897B', '#FDD835', '#1B5E20', '#C0CA33', '#AB47BC', '#827717',
    '#FF9800', '#AB47BC', '#C62828', '#FF8A65', '#81C784', '#5C6BC0', '#546E7A', '#00BCD4',
    '#8E24AA', '#D81B60', '#FFC107', '#2196F3', '#D32F2F', '#2E7D32', '#FBC02D', '#512DA8',
    '#C6FF00', '#76FF03', '#D1C4E9', '#E040FB', '#9575CD', '#FF7043', '#F48FB1', '#1976D2',
    '#CE93D8', '#80CBC4', '#795548', '#7986CB', '#00E676', '#C2185B', '#283593', '#C0CA33',
    '#9CCC65', '#FFAB91', '#26A69A', '#90A4AE', '#76FF03', '#90CAF9', '#C6FF00', '#F48FB1'
]
